export default {"src":"/_next/static/media/team_map.630e874b.svg","height":596,"width":759,"blurWidth":0,"blurHeight":0};